import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Text,
//   HStack,
//   VStack,
//   Divider,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Grid,
//   Image,
//   UnorderedList,
//   ListItem,
// } from "@chakra-ui/react";
import {
  Box,
  Text,
  Flex,
  Grid,
  GridItem,
  Divider,
  Heading,
  List,
  ListItem,
  OrderedList,
  Image,
  VStack,
  Table,
  Tr,
  Th,
  Thead,
  Tbody,
  Td,
  HStack,
  UnorderedList
} from '@chakra-ui/react'
import { format, parseISO, parse } from "date-fns";
import { formatMedicines } from "../../../middleware/domains/visits/patient-health/prescriptions";
import processPhysicalExamData from "../../../middleware/domains/visits/patient-health/physical-exam";
import moment from "moment";
import { CorrectMedicalTermsUsingAI } from "../../../middleware/services/visits/aicalls";
import useLoader from "../../loader/loaderstates";
import Toaster from "../../toaster";

const VisitSummary = ({ doctorNotes, patientHistory }) => {
  const {
    chiefcomplaint,
    _,
    doctorsassessment,
    vitals,
    reviewofsystem,
    orders,
    info,
    imagingresults,
    pharmacydetails,
  } = doctorNotes;

  const imagingResults = doctorNotes?.imagingresults;
  const pharmacyLocation = doctorNotes?.pharmacydetails;
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();

  const physicalexam = processPhysicalExamData(doctorNotes?.physicalexam);
  // console.log('physicalexam: ', physicalexam)
  // const generatePhysicalExamText = async (data) => {
  //   console.log('data: ', data)
  //   const inputToSave = {
  //     input: {
  //       text: data,
  //       type: "Physical Exam"
  //     },
  //   };

  //   showLoader();
  //   try {
  //     // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
  //     const result = await CorrectMedicalTermsUsingAI(inputToSave);
  //     if (result) {
  //       showSuccessToast("Updated Text");
  //       const updatedText = result?.text;
        
  //     }
  //   } catch (error) {
  //     console.error("Error in Correct AI call:", error);
  //     // showErrorToast("Error Happened While Correcting.");
  //     showErrorToast("Error in Correct AI call.");
  //   } finally {
  //     dismissLoader();
  //   }
  // };
  //     const [correctedPhysicalExam, setCorrectedPhysicalExam] = useState([]);
  //     const [isLoadingPhysicalExam, setIsLoadingPhysicalExam] = useState(false);
  // useEffect(() => {
  //   const fetchCorrectedPhysicalExam = async () => {
  //   if (doctorNotes?.physicalexam) {
  //     setIsLoadingPhysicalExam(true);
  //     try {
  //       const physicalexam = processPhysicalExamData(doctorNotes.physicalexam);
  //       const aiResponse = await generatePhysicalExamText(physicalexam);
        
  //       if (aiResponse && aiResponse.text) {
  //         setCorrectedPhysicalExam(aiResponse.text);
  //       } else {
  //         setCorrectedPhysicalExam(physicalexam);
  //       }
  //     } catch (error) {
  //       console.error("Failed to correct physical exam terms:", error);
  //       setCorrectedPhysicalExam(processPhysicalExamData(doctorNotes.physicalexam));
  //     } finally {
  //       setIsLoadingPhysicalExam(false);
  //     }
  //   }
  // };

  // fetchCorrectedPhysicalExam();


  // }, [doctorNotes?.physicalexam])

  const physicalexamtext = doctorNotes?.physicalexamtext?.description;

  // console.log(physicalexamtext);
  const hpitext = doctorNotes?.hpitext?.description;

  const generateOptions = (followupDetail) => {
    // Ensure followupDetail is a valid object
    followupDetail = followupDetail || {};

    const mappings = {
      referraltohighercenters: "Referral to Higher Centers",
      nutritionpacksforpregnantwomen: "Nutrition packs for pregnant women",
      ecg: "ECG",
      labs: "LABs",
      usgscanningforantenatalothers: "USG Scanning for Ante Natal/others",
      ivfluids: "IV Fluids",
      injectiblesforseasonaldiseases: "Injectibles for Seasonal Diseases",
      nebulizations: "Nebulizations",
      motprocedures: "MOT Procedures",
      otherminorot: "Other Minor OT",
      ipcases: "IP Cases",
      physiotherapycare: "Physiotherapy Care",
      ambulanceservice: "Ambulance Service",
    };

    return Object.entries(mappings)
      .filter(([key]) => followupDetail[key] === 1)
      .map(([, value]) => value);
  };

  const options = generateOptions(doctorNotes?.followupdetail);

  const services = options?.length > 0;

  const {
    hospitallogo,
    bookingid,
    hospitaladdress,
    patientname,
    patientgender,
    patientage,
    patientmrnid,
    patientphone,
    appointmentdate,
    drname,
    doctorqualification,
    doctorspeciality,
  } = info;

  const hospitalName = localStorage.getItem('hospitalname') ? localStorage.getItem('hospitalname') : "";

  const { medication, procedure, imaging, lab } = orders;

  const prescribedMedicines = medication ? formatMedicines(medication) : [];
  useEffect(() => {
    console.log('prescribedMEDICNES: ', prescribedMedicines)
  }, [prescribedMedicines])

  // Helper to get day from date
  const visitDate2 = new Date(info.appointmentdate);
  const visitDate = moment(info.appointmentdate).format("Do MMM, YYYY");
  // console.log(visitDate, visitDate2);
  // const visitDay = format(visitDate, "EEEE");
  const visitDay = format(visitDate2, "EEEE"); // Format to get the day of the week

 


// Format the date to 12-hour format with AM/PM
const formattedTime = moment(doctorNotes.info?.appointment_time, "HH:mm").format(
  "hh:mm A"
)


  // console.log("doctor", doctorNotes.time, moment(doctorNotes.time, "HH:mm").format(
  //   "hh:mm A"
  // ))

  function calculateAge(dob) {
    const dobDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDifference = today.getMonth() - dobDate.getMonth();
    const dayDifference = today.getDate() - dobDate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  }

  const generateDynamicTextForHPI = (value, patientGender, patientDob) => {
    let outputTexts = [];

    value.forEach((item, index) => {
      // Extract patient details
      let gender = patientGender || "";
      let age = calculateAge(patientDob) || "";

      // Initialize attributes
      let attributes = {};
      item.details.forEach((attribute) => {
        switch (attribute.attribute) {
          case "Site":
            attributes.site = attribute.values.map((v) => v.value).join(", ");
            break;
          case "Onset":
            attributes.onset = attribute.value;
            break;
          case "Chronicity":
            attributes.chronicity = attribute.value;
            break;
          case "Onset Quality":
            attributes.onsetQuality = attribute.value;
            break;
          case "Frequency":
            attributes.frequency = attribute.value;
            break;
          case "Associated Symptoms":
            attributes.symptoms = attribute.values
              .map((v) => v.value)
              .join(", ");
            break;
          case "Rating Scale":
            attributes.ratingScale = attribute.value;
            break;
          case "Time":
            attributes.time = attribute.value;
            break;
          case "Time Value":
            attributes.timeValue = attribute.value;
            break;
          default:
            break;
        }
      });

      // Construct patient text (only for the first item)
      let patientText =
        index === 0
          ? `The patient is a ${age}-year-old individual (${gender}) `
          : "";

      // Construct template based on available data, skipping sentences where data is missing
      let template = `${patientText}`;

      if (attributes.site) {
        template += `presenting with ${attributes.site} ${item.type}. `;
      }

      if (attributes.onset) {
        template += `The ${item.type} started ${attributes.onset} and `;
        if (attributes.chronicity) {
          template += `is described as ${attributes.chronicity} in nature. `;
        }
      }

      if (attributes.onsetQuality) {
        template += `The onset of the ${item.type} was ${attributes.onsetQuality}. `;
      }

      if (attributes.frequency) {
        template += `The ${item.type} is ${attributes.frequency} and `;
      }

      if (attributes.ratingScale) {
        template += `is rated as ${attributes.ratingScale} out of 10 in intensity. `;
      }

      if (attributes.symptoms) {
        template += `Associated with ${attributes.symptoms}.`;
      }

      // Push the constructed template to the outputTexts array
      outputTexts.push(template.trim());
    });

    return outputTexts;
  };

  const historyOfPresentIllness = generateDynamicTextForHPI(
    Array.isArray(doctorNotes?.historyofpresentillness)
      ? doctorNotes.historyofpresentillness
      : [],
    patientgender,
    patientage
  );

  const currentMedicines =
    patientHistory?.medicationForOverview?.length > 0
      ? patientHistory?.medicationForOverview.filter(
          (medicine) => medicine.iscurrentmedicine === 1
        )
      : [];

  // Helper to extract and format the required vitals
const getFormattedVitals = (vitalsArray) => {
  if (!Array.isArray(vitalsArray)) return {};

  // Find BP values
  const systolic = vitalsArray.find(v => v.vitalname === "Systolic Blood Pressure");
  const diastolic = vitalsArray.find(v => v.vitalname === "Diastolic Blood Pressure");
  const bp = systolic && diastolic
    ? `${systolic.vitalvalue}/${diastolic.vitalvalue} ${systolic.vitalunit}`
    : null;

  // Find other vitals
  const temperature = vitalsArray.find(v => v.vitalname === "Body Temperature");
  const pulse = vitalsArray.find(v => v.vitalname === "Pulse");
  const respRate = vitalsArray.find(v => v.vitalname === "Respiratory Rate");
  const spo2 = vitalsArray.find(v => v.vitalname === "Oxygen Saturation");

  return {
    bp,
    temperature: temperature ? `${temperature.vitalvalue}${temperature.vitalunit}` : null,
    pulse: pulse ? `${pulse.vitalvalue} ${pulse.vitalunit}` : null,
    respRate: respRate ? `${respRate.vitalvalue} ${respRate.vitalunit}` : null,
    spo2: spo2 ? `${spo2.vitalvalue}${spo2.vitalunit}` : null,
  };
};

const formattedVitals = getFormattedVitals(vitals);

  return (

    <Box maxW="4xl" mx="auto" bg="blue.50">
      {/* Header of Progress Notes */}
      <Box
        bg="linear-gradient(135deg, #5e96dfff 0%, #4c55abff 50%, #5d66edff 100%)"
        color="white" 
        p={6}
        // borderRadius="xl"
        // mb={6}
        boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.2)"
        position="relative"
        overflow="hidden"
      >
        {/* Background Pattern */}
        <Box
          position="absolute"
          top={0}
          right={0}
          w="200px"
          h="200px"
          bg="radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)"
          borderRadius="full"
          transform="translate(80px, -80px)"
        />  
          <Box position="relative" zIndex={1}>
            <Flex align="center" justify="space-between">
              {/* Left Section - Hospital Info */}
              <Box flex="3">
                <Flex align="center">
                  {hospitallogo && (
                    <Image 
                      src={hospitallogo} 
                      alt="Hospital Logo" 
                      boxSize="60px" 
                      mr={4}
                      bg="white"
                      p={1}
                      borderRadius="lg"
                      boxShadow="0 2px 8px rgba(0, 0, 0, 0.2)"
                    />
                  )}
                  <Box>
                    <Heading size="lg" mb={1} fontWeight="bold">
                      {hospitalName}
                    </Heading>
                    <Text fontSize="md" opacity={0.9} fontWeight="medium">
                      Excellence in Healthcare
                    </Text>
                  </Box>
                </Flex>
              </Box>

              {/* Right Section - Doctor Info */}
              <Box flex="1" textAlign="right">
                <VStack spacing={1} align="flex-end">
                  <Box textAlign="right">
                    <Text fontWeight="bold" fontSize="lg" mb={1}>
                      Dr. {drname}
                    </Text>
                    <Text fontSize="sm" opacity={0.9} fontWeight="medium">
                      {doctorqualification}
                    </Text>
                  </Box>
                  
                  <HStack spacing={4} align="center">
                    <Text fontSize="sm" opacity={0.9}>
                      <Text as="span" fontWeight="semibold">Speciality:</Text> {doctorspeciality}
                    </Text>
                  </HStack>
                  
                  <Text fontSize="sm" opacity={0.9}>
                    <Text as="span" fontWeight="semibold">Reg. No:</Text> {bookingid}
                  </Text>
                </VStack>
              </Box>
            </Flex>

            {/* Hospital Address - Compact */}
            {hospitaladdress && (
              <Box 
                mt={4} 
                pt={3} 
                borderTop="1px solid rgba(255,255,255,0.2)"
              >
                <Text fontSize="md" opacity={0.8} textAlign="center">
                  {hospitaladdress?.address}, {hospitaladdress?.city}, {hospitaladdress?.STATE}, {hospitaladdress?.country}
                </Text>
              </Box>
            )}
          </Box>
      </Box>

      {/* PAGE 1: AFTER VISIT SUMMARY */}
      <Box p={6} bg="blue.50" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break">
        <Box 
          bg="white" 
          p={5} 
          borderRadius="xl" 
          border="1px solid" 
          // borderColor="gray.200"
          borderColor="blue.100"
          boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          mb={6}
        >
          <Heading as="h1" fontSize="2xl" color="gray.600" fontWeight="bold" mb={2}>AFTER VISIT SUMMARY</Heading>
          <Divider borderColor="gray.300" my="12px" />

          <Text fontSize="md" color="gray.600">
            <Text as="strong">Patient Name: {patientname}</Text> <b>, MRN :</b> {patientHistory?.patientinfo?.uniqueid} <b>, Booking ID :</b> {bookingid}
          </Text>
          <Text fontSize="md" color="gray.600" mt={1}>
            📅 <b>Visit Date: </b> {visitDate}, <b>Visit Time: </b> {formattedTime} <Text mt={2} fontWeight='bold'> 📍{hospitaladdress?.address}, {hospitaladdress?.city},{" "}
            {hospitaladdress?.STATE}, {hospitaladdress?.country}</Text>
          </Text>
        </Box>

        <Grid templateColumns="repeat(2, 1fr)" gap={8} mb={8}>
          {/* Left Column - Instructions & Medications */}
          <GridItem>
            {/* Merged Instructions, Medicines & Pharmacy Section */}
            <Box 
              bg="white" 
              p={5} 
              borderRadius="xl" 
              border="1px solid" 
              // borderColor="gray.200"
              borderColor="blue.100"
              boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
              mb={6}
            >
              {/* Instructions Header */}
              <Heading as="h1" fontSize="xl" fontWeight="bold" mb={4}>
                Instructions <Text as='span' color="gray.600">from Dr. {drname}</Text>
              </Heading>
              <Divider borderColor="gray.300" my="12px" />

              {/* Today's Prescribed Medicines */}
              <Box mb={4}>
                <Heading as="h2" fontSize="xl" fontWeight="bold" mb={2}>
                  Today's Prescribed Medicines
                </Heading>
                
                <UnorderedList spacing={2}>
                  {prescribedMedicines.map((med, index) => (
                    <ListItem key={index} fontSize="lg" m={0}>
                      {med.name} {med.dosageforprescription ? `(${med.dosageforprescription})` : ""}
                    </ListItem>
                  ))}
                </UnorderedList>
                
                <Text fontSize="sm" color="gray.600" mt={2}>
                  Accurate as of <Text as='span' fontWeight="bold">{visitDate} at {formattedTime}.</Text> Review your updated medication list below.
                </Text>
              </Box>

              <Divider borderColor="gray.300" my="12px" />

              {/* Pharmacy Information */}
              {pharmacyLocation && (
                <Box>
                  <Text fontSize="md" fontWeight="bold" mb={2}>
                    Pick up these prescriptions at {pharmacyLocation?.pharmacyname} – {pharmacyLocation?.locationname || pharmacyLocation?.city || 'Local Pharmacy'}
                  </Text>
                  
                  <VStack align="start" spacing={1} fontSize="md" fontWeight='bold'>
                    {pharmacyLocation?.address1 && (
                      <Text>Address: {pharmacyLocation.address1}</Text>
                    )}
                    {pharmacyLocation?.address2 && (
                      <Text>{pharmacyLocation.address2}</Text>
                    )}
                    {(pharmacyLocation?.city || pharmacyLocation?.state || pharmacyLocation?.pincode) && (
                      <Text>
                        {pharmacyLocation.city && `${pharmacyLocation.city}, `}
                        {pharmacyLocation.state && `${pharmacyLocation.state} `}
                        {pharmacyLocation.pincode && `${pharmacyLocation.pincode}`}
                      </Text>
                    )}
                    {pharmacyLocation?.country && (
                      <Text>{pharmacyLocation.country}</Text>
                    )}
                    <Text mb={2} fontSize="sm" color="gray.600">Phone: {pharmacyLocation?.phone || 'Contact pharmacy for phone number'}</Text>
                  </VStack>
                </Box>
              )}
            </Box>

            {/* Follow-up Information - Redesigned */}
            <Box 
              bg="white" 
              p={5} 
              borderRadius="xl" 
              border="1px solid" 
              // borderColor="gray.200"
              borderColor="blue.100"
              boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
              mb={6}
            >
              <Heading as="h2" fontSize="xl" fontWeight="bold" mb={4}>
                Follow-up
              </Heading>
              <Divider borderColor="gray.300" my="12px" />
              
              {doctorNotes?.followupdetail?.referraldoctor || info.followupdate || doctorNotes?.followupdetail?.isfreevisit ? (
                <Grid templateColumns="repeat(2, 1fr)" gap={4} fontSize="sm" mb={3}>
                  <Box>
                    <Text fontWeight="semibold">Doctor:</Text>
                    <Text>
                      {doctorNotes?.followupdetail?.referraldoctor || "Dr. " + drname}
                    </Text>
                  </Box>
                  <Box>
                    <Text fontWeight="semibold">Follow-up Date:</Text>
                    <Text>
                      {info.followupdate ? format(new Date(info.followupdate), "dd MMM yyyy") : "N/A"}
                    </Text>
                  </Box>
                  <Box>
                    <Text fontWeight="semibold">Free Visit:</Text>
                    <Text>
                      {doctorNotes?.followupdetail?.isfreevisit ? "Yes" : "No"}
                    </Text>
                  </Box>
                </Grid>
              ) : (
                <Text fontSize="sm" color="gray.600" mb={3}>
                  There is no follow-up scheduled.
                </Text>
              )}
            </Box>

            {/* Information on File - Redesigned */}
            <Box 
              bg="white" 
              p={5} 
              borderRadius="xl" 
              border="1px solid" 
              // borderColor="gray.200"
              borderColor="blue.100"
              boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
            >
              <Heading as="h2" fontSize="xl" fontWeight="bold" mb={2}>Information on File</Heading>
              <Divider borderColor="gray.300" my="12px" />

              <Text fontSize="sm" mb={6}>
                <Text><b>Patient Name:</b> {patientname}</Text>
                <Text><b>Gender:</b> {patientgender}</Text>
                <Text><b>Phone:</b> {info.patientcountrycode} {patientphone}</Text>
                <Text><b>Date Of Birth:</b> {format(new Date(patientage), "dd MMM yyyy")}</Text>
                <Text><b>Visit Date & Time:</b> {`${visitDate} at ${formattedTime}`}</Text>
                <Text><b>Location:</b> {patientHistory?.patientinfo?.address}</Text>
                {/* <Text><b>Phone:</b> {info.patientcountrycode} {patientphone} &nbsp;&nbsp;&nbsp;&nbsp; <b>Date Of Birth:</b> {format(new Date(patientage), "dd MMM yyyy")}</Text> */}
              </Text>
            </Box>
          </GridItem>

          {/* Right Column */}
          <GridItem>
            <Box 
              bg="white" 
              p={5} 
              borderRadius="xl" 
              border="1px solid" 
              // borderColor="gray.200"
              borderColor="blue.100"
              boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
              mb={6}
            >
              <Heading as="h2" fontSize="xl" fontWeight="bold" mb={4}>
                Today's Visit Summary
              </Heading>
              <Divider borderColor="gray.300" my="12px" />
              
              <Text fontSize="sm">
                You consulted with <Text as="span" fontWeight="bold">Dr. {drname}, {doctorqualification}</Text> on{' '}
                <Text as="span" fontWeight="bold">{visitDay} {visitDate}</Text>. The following issue was addressed: <Text as="span" fontWeight="bold">{chiefcomplaint.chiefcomplaint}</Text>
              </Text>
              {/* <Box p={3} borderRadius="md">
                <Text fontSize="sm" fontWeight="semibold">
                  Primary Concern:
                </Text>
                <Text fontSize="sm" fontWeight="bold">
                  {chiefcomplaint.chiefcomplaint}
                </Text>
              </Box> */}
            </Box>

            {/* <Divider my="12px" /> */}

            {/* can use this if alignments issue */}
            {/* Visit Vitals Section */}
            {/* <Box mb={6} bg="white" p={4} borderRadius='xl' border="1px solid" borderColor="gray.200" boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)">
              <Heading as="h2" fontSize="lg" fontWeight="bold" mb={4}>
                Visit Vitals
              </Heading>
              
              {vitals && (
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                Blood Pressure
                <GridItem>
                  <Flex align="center">
                    <Box mr={3}>
                      <Text fontSize="xl">🩸</Text>
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="semibold" color="gray.600">
                        Blood Pressure:
                      </Text>
                      <Text fontSize="lg" fontWeight="bold">
                        {formattedVitals.bp || "-"}
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>

                Temperature
                <GridItem>
                  <Flex align="center">
                    <Box mr={3}>
                      <Text fontSize="xl">🌡️</Text>
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="semibold" color="gray.600">
                        Temperature:
                      </Text>
                      <Text fontSize="lg" fontWeight="bold">
                        {formattedVitals.temperature || "-"}
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>

                Pulse
                <GridItem>
                  <Flex align="center">
                    <Box mr={3}>
                      <Text fontSize="xl">💓</Text>
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="semibold" color="gray.600">
                        Pulse:
                      </Text>
                      <Text fontSize="lg" fontWeight="bold">
                        {formattedVitals.pulse ? formattedVitals.pulse.split(' ')[0] : "-"} bpm
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>

                Respiratory Rate
                <GridItem>
                  <Flex align="center">
                    <Box mr={3}>
                      <Text fontSize="xl">🫁</Text>
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="semibold" color="gray.600">
                        Resp Rate:
                      </Text>
                      <Text fontSize="lg" fontWeight="bold">
                        {formattedVitals.respRate ? formattedVitals.respRate.split(' ')[0] : "-"} bpm
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>

                Oxygen Saturation
                <GridItem colSpan={2}>
                  <Flex align="center">
                    <Box mr={3}>
                      <Text fontSize="xl">💨</Text>
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="semibold" color="gray.600">
                        Oxygen Saturation:
                      </Text>
                      <Text fontSize="lg" fontWeight="bold">
                        {formattedVitals.spo2 || "-"}
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>
              </Grid>
              )}
            </Box> */}

            {/* Visit Vitals Section - Updated */}
            <Box 
              bg="white" 
              p={6} 
              borderRadius="xl" 
              border="1px solid" 
              // borderColor="gray.200"
              borderColor="blue.100"
              boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
              mb={6}
            >
              <Heading as="h1" fontSize="xl" fontWeight="bold" mb={4}>
                Visit Vitals
              </Heading>
              <Divider borderColor="gray.300" my="12px" />
              
              {vitals && (
                <Grid templateColumns="repeat(2, 1fr)" gap={6}>
                  {/* Blood Pressure */}
                  <GridItem>
                    <Flex align="center">
                      <Box mr={4}>
                        <Text fontSize="2xl">🩸</Text>
                      </Box>
                      <Box>
                        <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={1}>
                          Blood Pressure:
                        </Text>
                        {/* <Text fontSize="xl" fontWeight="bold">
                          {formattedVitals.bp || "-"}
                        </Text> */}
                        <Text fontSize="xl" fontWeight="bold">
              {formattedVitals.bp ? formattedVitals.bp.split(' ')[0] : "-"}
              {formattedVitals.bp && (
                <Text as="span" fontSize="xs" fontWeight="normal" ml={1}>
                  mmHg
                </Text>
              )}
            </Text>
                      </Box>
                    </Flex>
                  </GridItem>

                  {/* Temperature */}
                  <GridItem>
                    <Flex align="center">
                      <Box mr={4}>
                        <Text fontSize="2xl">🌡️</Text>
                      </Box>
                      <Box>
                        <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={1}>
                          Temperature:
                        </Text>
                        {/* <Text fontSize="xl" fontWeight="bold">
                          {formattedVitals.temperature || "-"}
                        </Text> */}
                        <Text fontSize="xl" fontWeight="bold">
              {formattedVitals.temperature ? formattedVitals.temperature.split(' ')[0] : "-"}
              {formattedVitals.temperature && (
                <Text as="span" fontSize="xs" fontWeight="normal" ml={1}>
                  °F
                </Text>
              )}
            </Text>
                      </Box>
                    </Flex>
                  </GridItem>

                  {/* Pulse */}
                  <GridItem>
                    <Flex align="center">
                      <Box mr={4}>
                        <Text fontSize="2xl">💓</Text>
                      </Box>
                      <Box>
                        <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={1}>
                          Pulse:
                        </Text>
                        {/* <Text fontSize="xl" fontWeight="bold">
                          {formattedVitals.pulse ? formattedVitals.pulse.split(' ')[0] : "-"} bpm
                        </Text> */}
                        <Text fontSize="xl" fontWeight="bold">
              {formattedVitals.pulse ? formattedVitals.pulse.split(' ')[0] : "-"}
              {formattedVitals.pulse && (
                <Text as="span" fontSize="xs" fontWeight="normal" ml={1}>
                  bpm
                </Text>
              )}
            </Text>
                      </Box>
                    </Flex>
                  </GridItem>

                  {/* Respiratory Rate */}
                  <GridItem>
                    <Flex align="center">
                      <Box mr={4}>
                        <Text fontSize="2xl">🫁</Text>
                      </Box>
                      <Box>
                        <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={1}>
                          Resp Rate:
                        </Text>
                        {/* <Text fontSize="xl" fontWeight="bold">
                          {formattedVitals.respRate ? formattedVitals.respRate.split(' ')[0] : "-"} bpm
                        </Text> */}
                        <Text fontSize="xl" fontWeight="bold">
              {formattedVitals.respRate ? formattedVitals.respRate.split(' ')[0] : "-"}
              {formattedVitals.respRate && (
                <Text as="span" fontSize="xs" fontWeight="normal" ml={1}>
                  bpm
                </Text>
              )}
            </Text>
                      </Box>
                    </Flex>
                  </GridItem>

                  {/* Oxygen Saturation */}
                  <GridItem colSpan={2}>
                    <Flex align="center">
                      <Box mr={4}>
                        <Text fontSize="2xl">💨</Text>
                      </Box>
                      <Box>
                        <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={1}>
                          Oxygen Saturation:
                        </Text>
                        <Text fontSize="xl" fontWeight="bold">
                          {formattedVitals.spo2 || "-"}
                        </Text>
                        {/* <Text fontSize="xl" fontWeight="bold">
              {formattedVitals.spo2 ? formattedVitals.spo2.split(' ')[0] : "-"}
              {formattedVitals.spo2 && (
                <Text as="span" fontSize="xs" fontWeight="normal" ml={1}>
                  %
                </Text>
              )}
            </Text> */}
                      </Box>
                    </Flex>
                  </GridItem>
                </Grid>
              )}
            </Box>

            {/* Services Completed Today Section - Updated */}
            <Box 
              bg="white" 
              p={5} 
              borderRadius="xl" 
              border="1px solid" 
              borderColor="gray.200"
              boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
              // mb={4}
            >
              <Flex align="center" mb={4}>
                <Box 
                  bg="gray.100" 
                  color="gray.600" 
                  borderRadius="full" 
                  w={8} 
                  h={8} 
                  display="flex" 
                  alignItems="center" 
                  justifyContent="center" 
                  fontSize="sm"
                  fontWeight="bold"
                  mr={3}
                >
                  ✓
                </Box>
                <Text as="strong" fontSize="xl" fontWeight="bold">Orders Completed Today</Text>
              </Flex>
              <Divider borderColor="gray.300" my="12px" />

              {/* Diagnostic Services Section */}
              {orders && (
                <Box>
                  {/* Laboratory Investigations */}
                  {orders.lab && orders.lab.length > 0 && (
                    <Box mb={3}>
                      <Flex align="center" mb={1}>
                        <Box 
                          // bg="gray.100" 
                          // p={2} 
                          borderRadius="md" 
                          mr={2}
                        >
                          <Text fontSize="lg">🔬</Text>
                        </Box>
                        <Heading as="h3" fontSize="lg" fontWeight="bold">
                          Laboratory Investigations
                        </Heading>
                      </Flex>
                      <VStack align="start" spacing={3}>
                        {orders.lab.map((lab, index) => (
                          <Box 
                            key={index} 
                            // p={3}
                            pl={2} 
                            bg="white" 
                            borderRadius="lg" 
                            // border="1px solid"
                            // borderColor="gray.200"
                            width="full"
                          >
                            <Text fontWeight="semibold" fontSize="sm">{lab.ordername}</Text>
                            <Text fontSize="xs" color="gray.600">
                              Ordered: {new Date(lab.orderdate).toLocaleDateString()}
                            </Text>
                          </Box>
                        ))}
                      </VStack>
                    </Box>
                  )}

                  {/* Diagnostic Imaging */}
                  {orders.imaging && orders.imaging.length > 0 && (
                    <Box mb={3}>
                      <Flex align="center" mb={1}>
                        <Box 
                          // bg="gray.100" 
                          // p={2} 
                          borderRadius="md" 
                          mr={2}
                        >
                          <Text fontSize="lg">📷</Text>
                        </Box>
                        <Heading as="h3" fontSize="lg" fontWeight="bold">
                          Diagnostic Imaging
                        </Heading>
                      </Flex>
                      <VStack align="start" spacing={3}>
                        {orders.imaging.map((imaging, index) => (
                          <Box 
                            key={index} 
                            // p={3} 
                            pl={2} 
                            bg="white" 
                            borderRadius="lg" 
                            // border="1px solid"
                            // borderColor="gray.200"
                            width="full"
                          >
                            <Text fontWeight="semibold" fontSize="sm">{imaging.ordername}</Text>
                            <Text fontSize="xs" color="gray.600">
                              Ordered: {new Date(imaging.orderdate).toLocaleDateString()}
                            </Text>
                          </Box>
                        ))}
                      </VStack>
                    </Box>
                  )}

                  {/* Clinical Procedures */}
                  {orders.procedure && orders.procedure.length > 0 && (
                    <Box mb={3}>
                      <Flex align="center" mb={1}>
                        <Box 
                          // bg="gray.100" 
                          // p={2} 
                          borderRadius="md" 
                          mr={2}
                        >
                          <Text fontSize="lg">🛠️</Text>
                        </Box>
                        <Heading as="h3" fontSize="lg" fontWeight="bold">
                          Clinical Procedures
                        </Heading>
                      </Flex>
                      <VStack align="start" spacing={3}>
                        {orders.procedure.map((procedure, index) => (
                          <Box 
                            key={index} 
                            // p={3} 
                            pl={2}
                            bg="white" 
                            borderRadius="lg" 
                            // border="1px solid"
                            // borderColor="gray.200"
                            width="full"
                          >
                            <Text fontWeight="semibold" fontSize="sm">{procedure.ordername}</Text>
                            <Text fontSize="xs" color="gray.600">
                              Scheduled: {new Date(procedure.orderdate).toLocaleDateString()}
                            </Text>
                          </Box>
                        ))}
                      </VStack>
                    </Box>
                  )}

                  {/* Immunization Services */}
                  {orders.vaccinationdetail && orders.vaccinationdetail.length > 0 && (
                    <Box mb={3}>
                      <Flex align="center" mb={1}>
                        <Box 
                          // bg="gray.100" 
                          // p={2} 
                          borderRadius="md" 
                          mr={2}
                        >
                          <Text fontSize="lg">💉</Text>
                        </Box>
                        <Heading as="h3" fontSize="lg" fontWeight="bold">
                          Immunization Services
                        </Heading>
                      </Flex>
                      <VStack align="start" spacing={3}>
                        {orders.vaccinationdetail.map((vaccine, index) => (
                          <Box 
                            key={index} 
                            // p={3} 
                            pl={2}
                            bg="white" 
                            borderRadius="lg" 
                            // border="1px solid"
                            // borderColor="gray.200"
                            width="full"
                          >
                            <Text fontWeight="semibold" fontSize="sm">{vaccine.vaccinename}</Text>
                            <Text fontSize="xs" color="gray.600">
                              Administered: {new Date(vaccine.admindate).toLocaleDateString()}
                              {vaccine.duedate && (
                                <Text> • Next due: {new Date(vaccine.duedate).toLocaleDateString()}</Text>
                              )}
                            </Text>
                          </Box>
                        ))}
                      </VStack>
                    </Box>
                  )}

                  {/* No Services Message */}
                  {(!orders.lab || orders.lab.length === 0) && 
                  (!orders.imaging || orders.imaging.length === 0) && 
                  (!orders.procedure || orders.procedure.length === 0) && 
                  (!orders.vaccinationdetail || orders.vaccinationdetail.length === 0) && (
                    <Box 
                      textAlign="center" 
                      // p={4} 
                      // bg="gray.50" 
                      borderRadius="lg" 
                      // border="2px dashed"
                      // borderColor="gray.300"
                    >
                      <Text color="gray.500" fontStyle="italic">
                        No additional services were performed during today's visit.
                      </Text>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </GridItem>
        </Grid>

        <Divider borderColor="gray.300" my="12px" />

        {/* Bottom Sections */}
        {/* History Section */}
        <Box mt={8}>
          <Box 
            // bg="gray.800" 
            // bg="gray.400"
            // borderColor="gray.400"
            // color="white" 
            color="gray.600"
            // p={4} 
            borderRadius="xl" 
            mb={8}
            textAlign="left"
          >
            <Heading as="h1" fontSize="2xl" fontWeight="bold">
              📋 Medical History Overview
            </Heading>
            {/* <Text fontSize="sm" opacity={0.9}>
              Comprehensive Patient Health Records
            </Text> */}
          </Box>

          {/* Allergies Section */}
          <Box 
            bg="white" 
            p={5} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.200"
            boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={2}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                // borderRadius="full" 
                w={10} 
                h={10} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={3}
              >
                ⚠️
              </Box>
              <Box>
                <Heading as="h2" fontSize="lg" fontWeight="bold">
                  Allergies & Sensitivities
                </Heading>
                <Text fontSize="xs" color="gray.600">
                  Documented allergic reactions and sensitivities
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />

            {/* <Box bg="gray.50" p={4} borderRadius="lg"> */}
            <Box borderRadius="lg">
              {patientHistory?.allergy?.length > 0 ? (
                <VStack align="start" spacing={3}>
                  {patientHistory.allergy.map((allergy, index) => (
                    <Box 
                      key={index} 
                      bg="white" 
                      // p={3} 
                      pl={3}
                      borderRadius="md" 
                      width="full"
                      // borderLeft="4px solid"
                      // borderColor="gray.400"
                      // border="1px solid"
                      // borderColor="gray.200"
                    >
                      <Flex justify="space-between" align="flex-start">
                        <Box>
                          <Text fontSize="md" fontWeight="bold">
                            {allergy.allergyFrom}
                          </Text>
                          <Text fontSize="sm" color="gray.700">
                            {allergy.problems}
                          </Text>
                        </Box>
                        <Box 
                          // bg="gray.100" 
                          color="gray.700" 
                          px={2} 
                          py={1} 
                          borderRadius="full" 
                          fontSize="xs" 
                          fontWeight="bold"
                        >
                          {new Date(allergy.onSet).toLocaleDateString()}
                        </Box>
                      </Flex>
                    </Box>
                  ))}
                </VStack>
              ) : (
                <Box textAlign="center" py={4}>
                  <Text fontSize="sm" color="gray.500" fontStyle="italic">
                    🟢 No known allergies documented
                  </Text>
                </Box>
              )}
            </Box>
          </Box>

          {/* Medical Conditions Section */}
          <Box 
            bg="white" 
            p={5} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.200"
            boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={2}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={10} 
                h={10} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={3}
              >
                🫀
              </Box>
              <Box>
                <Heading as="h2" fontSize="lg" fontWeight="bold">
                  Medical Conditions
                </Heading>
                <Text fontSize="xs" color="gray.600">
                  Chronic and acute health conditions
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />

            <Box borderRadius="lg">
              {patientHistory?.medicalhistory?.length > 0 ? (
                <VStack align="start" spacing={3}>
                  {patientHistory.medicalhistory.map((condition, index) => (
                    <Box 
                      key={index} 
                      bg="white" 
                      // p={3} 
                      pl={3}
                      borderRadius="md" 
                      width="full"
                      // borderLeft="4px solid"
                      // borderColor="gray.400"
                      // border="1px solid"
                      // borderColor="gray.200"
                    >
                      <Flex justify="space-between" align="flex-start">
                        <Box flex="1">
                          <Text fontSize="md" fontWeight="bold">
                            {condition.condition}
                          </Text>
                          {condition.conditiontype && (
                            <Text fontSize="sm" color="gray.600">
                              Type: {condition.conditiontype}
                            </Text>
                          )}
                        </Box>
                        <Box 
                          // bg="gray.100" 
                          color="gray.700" 
                          px={2} 
                          py={1} 
                          borderRadius="full" 
                          fontSize="xs" 
                          fontWeight="bold"
                          minW="100px"
                          textAlign="center"
                        >
                          Since {new Date(condition.conditionidentifieddate).toLocaleDateString()}
                        </Box>
                      </Flex>
                    </Box>
                  ))}
                </VStack>
              ) : (
                <Box textAlign="center" py={4}>
                  <Text fontSize="sm" color="gray.500" fontStyle="italic">
                    🟢 No medical conditions documented
                  </Text>
                </Box>
              )}
            </Box>
          </Box>

          {/* Surgical History Section */}
          <Box 
            bg="white" 
            p={5} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.200"
            boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={2}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={10} 
                h={10} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={3}
              >
                🏥
              </Box>
              <Box>
                <Heading as="h2" fontSize="lg" fontWeight="bold">
                  Surgical Procedures
                </Heading>
                <Text fontSize="xs" color="gray.600">
                  Previous surgical interventions and operations
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />

            <Box borderRadius="lg">
              {patientHistory?.surgicalhistory?.length > 0 ? (
                <VStack align="start" spacing={3}>
                  {patientHistory.surgicalhistory.map((surgery, index) => (
                    <Box 
                      key={index} 
                      bg="white" 
                      // p={3} 
                      pl={3}
                      borderRadius="md" 
                      width="full"
                      // borderLeft="4px solid"
                      // borderColor="gray.400"
                      // border="1px solid"
                      // borderColor="gray.200"
                    >
                      <Text fontSize="md" fontWeight="bold">
                        {surgery.surgeryName}
                      </Text>
                      <Grid templateColumns="repeat(2, 1fr)" gap={2} fontSize="sm">
                        {surgery.doctorName && (
                          <Box>
                            <Text color="gray.600">Surgeon:</Text>
                            <Text fontWeight="medium">{surgery.doctorName}</Text>
                          </Box>
                        )}
                        {surgery.hospital && (
                          <Box>
                            <Text color="gray.600">Hospital:</Text>
                            <Text fontWeight="medium">{surgery.hospital}</Text>
                          </Box>
                        )}
                        <Box colSpan={2}>
                          <Text color="gray.600">Date:</Text>
                          <Text fontWeight="medium">
                            {new Date(surgery.date).toLocaleDateString()}
                          </Text>
                        </Box>
                      </Grid>
                    </Box>
                  ))}
                </VStack>
              ) : (
                <Box textAlign="center" py={4}>
                  <Text fontSize="sm" color="gray.500" fontStyle="italic">
                    🟢 No surgical procedures documented
                  </Text>
                </Box>
              )}
            </Box>
          </Box>

          {/* Current Medications Section */}
          <Box 
            bg="white" 
            p={5} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.200"
            boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          >
            <Flex align="center" mb={2}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={10} 
                h={10} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={3}
              >
                💊
              </Box>
              <Box>
                <Heading as="h2" fontSize="lg" fontWeight="bold">
                  Current Medications
                </Heading>
                <Text fontSize="xs" color="gray.600">
                  Ongoing pharmaceutical treatments
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />

            <Box borderRadius="lg">
              {currentMedicines?.length > 0 ? (
                <VStack align="start" spacing={3}>
                  {currentMedicines.map((medicine, index) => (
                    <Box 
                      key={index} 
                      bg="white" 
                      // p={3} 
                      pl={3}
                      borderRadius="md" 
                      width="full"
                      // borderLeft="4px solid"
                      // borderColor="gray.400"
                      // border="1px solid"
                      // borderColor="gray.200"
                    >
                      <Text fontSize="md" fontWeight="bold">
                        {medicine.medicinetype && medicine.medicinetype + ":"} {medicine.medicinename}
                      </Text>
                      {medicine.chemicalcomposition && (
                        <Text fontSize="sm" color="gray.600">
                          Composition: {medicine.chemicalcomposition}
                        </Text>
                      )}
                      <Flex justify="space-between" align="center" fontSize="xs">
                        <Text color="gray.600">
                          Prescribed by: {medicine.prescribedby}
                          {medicine.prescribedhospitalname && ` at ${medicine.prescribedhospitalname}`}
                        </Text>
                        <Box 
                          // bg="gray.100" 
                          color="gray.700" 
                          px={2} 
                          py={1} 
                          borderRadius="full" 
                          fontWeight="bold"
                        >
                          Current
                        </Box>
                      </Flex>
                    </Box>
                  ))}
                </VStack>
              ) : (
                <Box textAlign="center" py={4}>
                  <Text fontSize="sm" color="gray.500" fontStyle="italic">
                    🟢 No current medications documented
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <Divider borderColor="gray.300" my="12px" />

      {/* PAGE 2: YOUR RESULTS */}
      <Box p={8} bg="blue.50" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break">
        {/* Header Section */}
        <Box 
          // bg="linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%)" 
          // bg="gray.400"
          color="gray.600"
          // p={4} 
          borderRadius="xl" 
          mb={8}
          textAlign="left"
          // boxShadow="0 8px 20px -4px rgba(58, 60, 61, 0.09)"
          // boxShadow="0 8px 20px -4px rgba(66, 68, 70, 0.09)"
        >
          <Heading as="h1" fontSize="2xl" fontWeight="bold">
            📊 Diagnostic Results & Reports
          </Heading>
          {/* <Text fontSize="md" opacity={0.9}>
            Comprehensive Analysis of Your Medical Investigations
          </Text> */}
        </Box>

        {imagingResults?.length > 0 ? (
          <VStack spacing={8} align="stretch">
            {imagingResults.map((result, index) => (
              <Box 
                key={index}
                bg="white"
                borderRadius="xl"
                border="1px solid"
                borderColor="blue.100"
                boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
                overflow="hidden"
                _hover={{ 
                  boxShadow: "0 8px 25px -5px rgba(0, 0, 0, 0.15)",
                  transform: "translateY(-2px)"
                }}
                transition="all 0.3s ease"
              >
                {/* Report Header */}
                <Box 
                  // bg="blue.50" 
                  // bg="gray.100"
                  p={5} 
                  borderBottom="1px solid" 
                  borderColor="gray.100"
                >
                  <Flex justify="space-between" align="flex-start" mb={3}>
                    <Box flex="1">
                      <Heading as="h2" fontSize="xl" fontWeight="bold" color="blue.800" mb={2}>
                        {result.reportname}
                      </Heading>
                      {/* <Flex align="center" fontSize="sm" color="blue.600"> */}
                      <Flex align="center" fontSize="sm" color="gray.600">
                        <Box mr={2}>📅</Box>
                        <Text fontWeight="medium">
                          Resulted on {new Date(result.verifieddate).toLocaleDateString()}
                        </Text>
                      </Flex>
                    </Box>
                    <Box 
                      // bg="blue.100" 
                      // bg="gray.400"
                      // color="blue.700" 
                      color="gray.700" 
                      px={3} 
                      py={1} 
                      borderRadius="full" 
                      fontSize="sm" 
                      fontWeight="bold"
                    >
                      Report #{index + 1}
                    </Box>
                  </Flex>
                  
                  <Flex align="center" fontSize="sm" color="gray.700">
                    <Box mr={2}>👨‍⚕️</Box>
                    <Text fontWeight="medium">
                      Authorized by <Text as="span" fontWeight="bold">Dr. {drname}</Text>
                    </Text>
                  </Flex>
                </Box>

                {/* Report Content */}
                <Box p={6}>
                  {/* Report Description */}
                  <Box mb={6}>
                    <Flex align="center" mb={3}>
                      <Box 
                        // bg="purple.100" 
                        // bg="gray.100"
                        // color="purple.600" 
                        color="gray.600" 
                        borderRadius="md" 
                        // p={2} 
                        mr={3}
                      >
                        📝
                      </Box>
                      {/* <Heading as="h3" fontSize="lg" fontWeight="bold" color="purple.700"> */}
                      <Heading as="h3" fontSize="lg" fontWeight="bold" color="gray.600">
                        Report Description
                      </Heading>
                    </Flex>
                    <Box 
                      // bg="purple.50" 
                      // bg="gray.50" 
                      // p={4}
                      pl={4} 
                      borderRadius="lg" 
                      // borderLeft="4px solid" 
                      // borderColor="gray.400"
                    >
                      <Text fontSize="sm" lineHeight="relaxed" color="gray.700">
                        {result.reportdescription}
                      </Text>
                    </Box>
                  </Box>

                  {/* Results Grid */}
                  <Grid templateColumns="repeat(2, 1fr)" gap={6} mb={8}>
                    {/* Normal Findings */}
                    <Box>
                      <Flex align="center" mb={3}>
                        <Box 
                          // bg="green.100" 
                          // bg="gray.100"
                          color="green.600" 
                          borderRadius="md" 
                          // p={2} 
                          mr={3}
                        >
                          ✅
                        </Box>
                        {/* <Heading as="h3" fontSize="md" fontWeight="bold" color="green.700"> */}
                      <Heading as="h3" fontSize="lg" fontWeight="bold" color="gray.600">
                          Normal Findings
                        </Heading>
                      </Flex>
                      <Box 
                        // bg="green.50" 
                        // bg="gray.50" 
                        // p={4} 
                        pl={4}
                        borderRadius="lg" 
                        // borderLeft="4px solid" 
                        // borderColor="gray.400"
                        height="full"
                      >
                        <Text fontSize="sm" lineHeight="relaxed" color="gray.700">
                          {result.results_interpretation.normal_results || "No significant abnormalities detected"}
                        </Text>
                      </Box>
                    </Box>

                    {/* Abnormal Findings */}
                    <Box>
                      <Flex align="center" mb={3}>
                        <Box 
                          // bg="orange.100" 
                          // bg="gray.100" 
                          color="orange.600" 
                          borderRadius="md" 
                          // p={2} 
                          mr={3}
                        >
                          ⚠️
                        </Box>
                        {/* <Heading as="h3" fontSize="md" fontWeight="bold" color="orange.700"> */}
                      <Heading as="h3" fontSize="lg" fontWeight="bold" color="gray.600">
                          Abnormal Findings
                        </Heading>
                      </Flex>
                      <Box 
                        // bg="orange.50" 
                        // bg="gray.50" 
                        // p={4} 
                        pl={4}
                        borderRadius="lg" 
                        // borderLeft="4px solid" 
                        // borderColor="gray.400"
                        height="full"
                      >
                        <Text fontSize="sm" lineHeight="relaxed" color="gray.700">
                          {result.results_interpretation.abnormal_results || "No abnormal findings reported"}
                        </Text>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Clinical Interpretation */}
                  <Box mb={6} mt={4}>
                    <Flex align="center" mb={3}>
                      <Box 
                        // bg="blue.100" 
                        // bg="gray.100" 
                        color="gray.600" 
                        borderRadius="md" 
                        // p={2} 
                        mr={3}
                      >
                        🔍
                      </Box>
                      {/* <Heading as="h3" fontSize="lg" fontWeight="bold" color="blue.700"> */}
                      <Heading as="h3" fontSize="lg" fontWeight="bold" color="gray.600">
                        Clinical Interpretation
                      </Heading>
                    </Flex>
                    <Box 
                      // bg="blue.50" 
                      // bg="gray.50" 
                      // p={4} 
                      pl={4}
                      borderRadius="lg" 
                      // borderLeft="4px solid" 
                      // borderColor="gray.400"
                    >
                      <Text fontSize="sm" lineHeight="relaxed" color="gray.700">
                        {result.results_interpretation.report_interpretation || "Standard clinical interpretation applied"}
                      </Text>
                    </Box>
                  </Box>

                  {/* Report Footer */}
                  {/* <Box 
                    bg="gray.50" 
                    p={4} 
                    borderRadius="lg" 
                    border="1px solid" 
                    borderColor="gray.200"
                  >
                    <Flex align="center" justify="center">
                      <Box mr={3}>🏥</Box>
                      <Text fontSize="xs" color="gray.600" textAlign="center">
                        Electronically verified and documented for medical records
                      </Text>
                    </Flex>
                  </Box> */}
                </Box>
              </Box>
            ))}
          </VStack>
        ) : (
          /* No Results State */
          <Box 
            textAlign="center" 
            py={12} 
            // bg="gray.50" 
            bg="white" 
            borderRadius="xl" 
            // border="2px dashed" 
            // borderColor="gray.300"
          >
            <Box fontSize="4xl" mb={4} color="gray.400">
              📄
            </Box>
            <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.600" mb={2}>
              No Diagnostic Reports Available
            </Heading>
            {/* <Text fontSize="sm" color="gray.500" maxW="md" mx="auto">
              Your diagnostic results and imaging reports will appear here once they are processed and verified by our medical team.
            </Text> */}
          </Box>
        )}

        <Divider borderColor="gray.300" my="12px" />

        <Box 
          // bg="linear-gradient(135deg, #4a5568 0%, #2d3748 100%)" 
          // bg="gray.400"
          color="gray.600" 
          // p={4} 
          borderRadius="xl" 
          mt={8}
          mb={6}
          // mt={12}
          // mb={8}
          textAlign="left"
        >
          <Heading as="h1" fontSize="2xl" fontWeight="bold">
            🩺 Clinical Progress Notes
          </Heading>
          {/* <Text fontSize="md" opacity={0.9}>
            Detailed Medical Assessment and Treatment Plan
          </Text> */}
        </Box>

        {/* Progress Notes Section - Redesigned */}
      <Box mt={8}>
        {/* History of Present Illness */}
        {historyOfPresentIllness.length > 0 && (
          <Box 
            bg="white" 
            p={6} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.100"
            boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={4}>
              <Box 
                // bg="purple.100" 
                // bg="gray.100" 
                color="purple.600" 
                borderRadius="full" 
                w={12} 
                h={12} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={1}
              >
                📋
              </Box>
              <Box>
                <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.700">
                  History of Present Illness
                </Heading>
                <Text fontSize="sm" color="gray.600">
                  Patient-reported symptoms and medical history
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />  

            <Box pl={4} borderRadius="lg">
              <VStack align="start" spacing={4}>
                {historyOfPresentIllness.map((note, index) => (
                  <Box 
                    key={index}
                    // bg="white"
                    // p={4}
                    borderRadius="lg"
                    width="full"
                    // borderLeft="4px solid"
                    // borderColor="gray.400"
                    // boxShadow="0 2px 8px rgba(0, 0, 0, 0.05)"
                  >
                    <Flex align="flex-start">
                      <Box 
                        bg="gray.100" 
                        color="gray.600" 
                        borderRadius="full" 
                        w={6} 
                        h={6} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center" 
                        fontSize="xs"
                        fontWeight="bold"
                        mr={2}
                        mt={1}
                        flexShrink={0}
                      >
                        {index + 1}
                      </Box>
                      <Text fontSize="sm" textAlign="justify" color="gray.700" lineHeight="1.6">
                        {note}
                      </Text>
                    </Flex>
                  </Box>
                ))}
              </VStack>
              
              {hpitext && (
                <Box 
                  bg="white" 
                  // p={4} 
                  pl={8}
                  borderRadius="lg" 
                  mt={1}
                  // border="1px solid"
                  // borderColor="purple.200"
                >
                  <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                    Additional Notes:
                  </Text>
                  <Text fontSize="sm" textAlign="justify" color="gray.700" lineHeight="1.6">
                    {hpitext}
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        )}

      {/* Visit Vitals in Progress Notes */}
        {/* {vitals?.length > 0 && (
        <Box 
          bg="white" 
          p={6} 
          borderRadius="xl" 
          border="1px solid" 
          borderColor="purple.100"
          boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
          mb={6}
        >
          <Flex align="center" mb={4}>
            <Box 
              // bg="gray.100" 
              color="purple.600" 
              borderRadius="full" 
              w={12} 
              h={12} 
              display="flex" 
              alignItems="center" 
              justifyContent="center" 
              fontSize="lg"
              fontWeight="bold"
              mr={1}
            >
              📊
            </Box>
            <Box>
              <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.700">
                Clinical Vitals Record
              </Heading>
              <Text fontSize="sm" color="gray.600">
                Measured physiological parameters during visit
              </Text>
            </Box>
          </Flex>

          <Divider borderColor="gray.300" my="12px" />  

          <Box bg="gray.50" p={5} borderRadius="lg">
            <VStack align="start" spacing={4}>
              {(() => {
                // Group vitals and merge BP readings
                const groupedVitals = [];
                const systolic = vitals.find(v => v.vitalname === "Systolic Blood Pressure");
                const diastolic = vitals.find(v => v.vitalname === "Diastolic Blood Pressure");
                
                // Add merged BP if both systolic and diastolic exist
                if (systolic && diastolic) {
                  groupedVitals.push({
                    vitalname: "Blood Pressure",
                    vitalvalue: `${systolic.vitalvalue}/${diastolic.vitalvalue}`,
                    vitalunit: systolic.vitalunit,
                    isMergedBP: true
                  });
                }
                
                // Add other vitals excluding systolic and diastolic
                vitals.forEach(vital => {
                  if (vital.vitalname !== "Systolic Blood Pressure" && 
                      vital.vitalname !== "Diastolic Blood Pressure") {
                    groupedVitals.push(vital);
                  }
                });

                return groupedVitals.map((vital, index) => (
                  <Box 
                    key={index}
                    bg="white"
                    p={4}
                    borderRadius="lg"
                    width="full"
                    borderLeft="4px solid"
                    borderColor="gray.400"
                  >
                    <Flex align="flex-start">
                      <Box 
                        bg="gray.100" 
                        color="gray.600" 
                        borderRadius="full" 
                        w={6} 
                        h={6} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center" 
                        fontSize="xs"
                        fontWeight="bold"
                        mr={3}
                        mt={1}
                        flexShrink={0}
                      >
                        {index + 1}
                      </Box>
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.800" mb={1}>
                          {vital.vitalname}:
                        </Text>
                        <Text fontSize="sm" color="gray.700" lineHeight="1.6">
                          {vital.vitalvalue} {vital.vitalunit}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                ));
              })()}
            </VStack>
          </Box>
        </Box>
      )} */}

        {/* Visit Vitals in Progress Notes */}
        {vitals && vitals.length > 0 && (
          <Box 
            bg="white" 
            p={6} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.100"
            boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={4}>
              <Box 
                // bg="gray.100" 
                color="purple.600" 
                borderRadius="full" 
                w={12} 
                h={12} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={1}
              >
                📊
              </Box>
              <Box>
                <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.700">
                  Clinical Vitals Record
                </Heading>
                <Text fontSize="sm" color="gray.600">
                  Measured physiological parameters during visit
                </Text>
              </Box>
            </Flex>

            {/* <Divider borderColor="gray.300" my="12px" />   */}

            <Box borderRadius="lg">
              <Grid templateColumns="repeat(auto-fit, minmax(200px, 1fr))" gap={4}>
                {(() => {
                // Group vitals and merge BP readings
                const groupedVitals = [];
                const systolic = vitals.find(v => v.vitalname === "Systolic Blood Pressure");
                const diastolic = vitals.find(v => v.vitalname === "Diastolic Blood Pressure");
                
                // Add merged BP if both systolic and diastolic exist
                if (systolic && diastolic) {
                  groupedVitals.push({
                    vitalname: "Blood Pressure",
                    vitalvalue: `${systolic.vitalvalue}/${diastolic.vitalvalue}`,
                    vitalunit: systolic.vitalunit,
                    isMergedBP: true
                  });
                }
                
                // Add other vitals excluding systolic and diastolic
                vitals.forEach(vital => {
                  if (vital.vitalname !== "Systolic Blood Pressure" && 
                      vital.vitalname !== "Diastolic Blood Pressure") {
                    groupedVitals.push(vital);
                  }
                });

                return groupedVitals.map((vital, index) => (
                  <Box 
                    key={index}
                    bg="white"
                    p={4}
                    borderRadius="lg"
                    textAlign="center"
                    // border="1px solid"
                    // borderColor="gray.200"
                    _hover={{ transform: "translateY(-2px)", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}
                    transition="all 0.2s"
                  >
                    <Text fontSize="sm" fontWeight="semibold" color="blue.700" mb={2}>
                      {vital.vitalname}
                    </Text>
                    <Text fontSize="lg" fontWeight="bold" color="blue.800" mb={1}>
                      {vital.vitalvalue} {vital.vitalunit}
                    </Text>
                    <Text fontSize="xs" color="blue.600">
                      Measured during consultation
                    </Text>
                  </Box>
                ));
              })()}
                {/* {vitals.map((vital, index) => (
                  <Box 
                    key={index}
                    bg="white"
                    p={4}
                    borderRadius="lg"
                    textAlign="center"
                    border="1px solid"
                    borderColor="blue.200"
                    _hover={{ transform: "translateY(-2px)", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}
                    transition="all 0.2s"
                  >
                    <Text fontSize="sm" fontWeight="semibold" color="blue.700" mb={2}>
                      {vital.vitalname}
                    </Text>
                    <Text fontSize="lg" fontWeight="bold" color="blue.800" mb={1}>
                      {vital.vitalvalue} {vital.vitalunit}
                    </Text>
                    <Text fontSize="xs" color="blue.600">
                      Measured during consultation
                    </Text>
                  </Box>
                ))} */}
              </Grid>
            </Box>
          </Box>
        )}

        {/* Physical Exam */}
        {physicalexam && physicalexam.length > 0 && (
          <Box 
            bg="white" 
            p={6} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.100"
            boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={4}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={12} 
                h={12} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={1}
              >
                🔍
              </Box>
              <Box>
                <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.700">
                  Physical Examination
                </Heading>
                <Text fontSize="sm" color="gray.600">
                  Clinical assessment and physical findings
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />  

            <Box borderRadius="lg">
              <VStack align="start" spacing={4}>
                {physicalexam.map((exam, index) => (
                  <Box 
                    key={index}
                    bg="white"
                    // p={4}
                    pl={4}
                    borderRadius="lg"
                    width="full"
                    // borderLeft="4px solid"
                    // borderColor="gray.400"
                  >
                    <Flex align="flex-start">
                      <Box 
                        bg="gray.100" 
                        color="gray.600" 
                        borderRadius="full" 
                        w={6} 
                        h={6} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center" 
                        fontSize="xs"
                        fontWeight="bold"
                        mr={3}
                        mt={1}
                        flexShrink={0}
                      >
                        {index + 1}
                      </Box>
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                          {exam.type}:
                        </Text>
                        <Text fontSize="sm" color="gray.700" lineHeight="1.6">
                          {exam.condition}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                ))}
              </VStack>
              
              {physicalexamtext && (
                <Box 
                  bg="white" 
                  // p={4} 
                  pl={8}
                  borderRadius="lg" 
                  mt={1}
                  // border="1px solid"
                  // borderColor="gray.200"
                >
                  <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                    Clinical Observations:
                  </Text>
                  <Text fontSize="sm" textAlign="justify" color="gray.700" lineHeight="1.6">
                    {physicalexamtext}
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        )}        

        {/* Review of Systems */}
        {reviewofsystem && reviewofsystem.length > 0 && (
          <Box 
            bg="white" 
            p={6} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.100"
            boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={4}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={12} 
                h={12} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={1}
              >
                🩺
              </Box>
              <Box>
                <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.700">
                  Review of Systems
                </Heading>
                <Text fontSize="sm" color="gray.600">
                  Comprehensive system-by-system assessment
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />  

            <Box borderRadius="lg">
              <VStack align="start" spacing={4}>
                {reviewofsystem.map((ros, index) => (
                  <Box 
                    key={index}
                    bg="white"
                    // p={4}
                    pl={4}
                    borderRadius="lg"
                    width="full"
                    // borderLeft="4px solid"
                    // borderColor="gray.400"
                  >
                    <Flex align="flex-start">
                      <Box 
                        bg="gray.100" 
                        color="gray.600" 
                        borderRadius="full" 
                        w={6} 
                        h={6} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center" 
                        fontSize="xs"
                        fontWeight="bold"
                        mr={3}
                        mt={1}
                        flexShrink={0}
                      >
                        {index + 1}
                      </Box>
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                          {ros.rosname}:
                        </Text>
                        <Text fontSize="sm" color="gray.700" lineHeight="1.6">
                          {ros.rosvalue.map((r) => r.value).join(", ")}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                ))}
              </VStack>
            </Box>
          </Box>
        )}

        {/* Doctor's Assessment */}
        {doctorsassessment && doctorsassessment.length > 0 && (
          <Box 
            bg="white" 
            p={6} 
            borderRadius="xl" 
            border="1px solid" 
            borderColor="gray.100"
            boxShadow="0 4px 12px -2px rgba(0, 0, 0, 0.1)"
            mb={6}
          >
            <Flex align="center" mb={4}>
              <Box 
                // bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={12} 
                h={12} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="lg"
                fontWeight="bold"
                mr={1}
              >
                💡
              </Box>
              <Box>
                <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.700">
                  Assessment & Plan
                </Heading>
                <Text fontSize="sm" color="gray.600">
                  Clinical diagnosis and treatment recommendations
                </Text>
              </Box>
            </Flex>

            <Divider borderColor="gray.300" my="12px" />  

            {/* <Box bg="gray.50" p={5} borderRadius="lg"> */}
            <Box borderRadius="lg">
              <VStack align="start" spacing={4}>
                {doctorsassessment.map((assessment, index) => (
                  <Box 
                    key={index}
                    bg="white"
                    // p={4}
                    pl={4}
                    borderRadius="lg"
                    width="full"
                    // borderLeft="4px solid"
                    // borderColor="gray.400"
                  >
                    <Flex align="flex-start">
                      <Box 
                        bg="gray.100" 
                        color="gray.600" 
                        borderRadius="full" 
                        w={6} 
                        h={6} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center" 
                        fontSize="xs"
                        fontWeight="bold"
                        mr={3}
                        mt={1}
                        flexShrink={0}
                      >
                        {index + 1}
                      </Box>
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                          {assessment.diagnosis}:
                        </Text>
                        <Text fontSize="sm" color="gray.700" lineHeight="1.6">
                          {assessment.plan}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                ))}
              </VStack>
            </Box>
          </Box>
        )}
      </Box>

      <Divider borderColor="gray.300" my="12px" />


        {/* Prescribed Medicines */}
      {prescribedMedicines && prescribedMedicines.length > 0 && (
        <VStack align="start" width="100%" spacing={4}>
          <Box 
          // bg="linear-gradient(135deg, #4a5568 0%, #2d3748 100%)" 
          // bg="gray.400"
          color="gray.600" 
          w='100%'
          // p={4} 
          // pl={4}
          borderRadius="xl" 
          mt={6}
          mb={2}
          // mt={12}
          // mb={8}
          textAlign="left"
        >
          <Heading as="h1" fontSize="2xl" fontWeight="bold">
            🩺 Prescribed Medicines
          </Heading>
          {/* <Text fontSize="md" opacity={0.9}>
            Detailed Medical Assessment and Treatment Plan
          </Text> */}
        </Box>
          
        <Box 
          bg="white" 
          p={1} 
          borderRadius="xl" 
          border="1px solid" 
          borderColor="gray.300"
          boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          width="100%"
        >
          <Table
            variant="simple"
            width="full"
            size="md"
            bg="white"
            border="1px solid"
            borderColor="gray.300"
            borderRadius="md"
            overflow="hidden"
          >
            <Thead bg="gray.100">
              <Tr>
                <Th 
                  fontSize="16px" 
                  fontWeight="bold" 
                  borderRight="1px solid" 
                  borderColor="gray.300"
                  py={3}
                >
                  MEDICINE
                </Th>
                <Th 
                  fontSize="16px" 
                  fontWeight="bold" 
                  borderRight="1px solid" 
                  borderColor="gray.300"
                  textAlign="center"
                  py={3}
                  width="120px"
                >
                  DOSE
                </Th>
                <Th 
                  fontSize="16px" 
                  fontWeight="bold" 
                  borderBottom="1px solid"
                  borderColor="gray.300"
                  textAlign="center"
                  py={3}
                >
                  TIMING • FREQUENCY • DURATION
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {prescribedMedicines.map((med, index) => {
                // Calculate duration in days
                const startDate = new Date(med.medicationstartdate);
                const endDate = new Date(med.medicationenddate);
                const durationDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
                
                // Format timing information
                const timingParts = [];
                if (med.beforefood) timingParts.push("Before food");
                if (med.afterfood) timingParts.push("After food");
                const timingStr = timingParts.length > 0 ? timingParts.join(" • ") : "As directed";
                
                // Format frequency display
                const frequencyParts = [];
                if (med.morning) frequencyParts.push("Morning");
                if (med.afternoon) frequencyParts.push("Afternoon");
                if (med.evening) frequencyParts.push("Evening");
                if (med.night) frequencyParts.push("Night");
                const frequencyDisplay = frequencyParts.join(", ") || "As needed";
                
                return (
                  <Tr 
                    key={index} 
                    // _even={{ bg: "gray.50" }}
                    borderBottom="1px solid"
                    borderColor="gray.300"
                  >
                    <Td
                      fontWeight="semibold"
                      fontSize="14px"
                      borderRight="1px solid"
                      borderColor="gray.300"
                      verticalAlign="top"
                      py={3}
                    >
                      <Text fontWeight='semibold' mb={1}>
                        {index + 1}. {med.name}
                        {med.dosageforprescription ? (
                          <>({med.dosageforprescription})</>
                        ) : null}
                      </Text>
                      {med.chemicalcomposition && (
                        <Text fontSize="12px" color="gray.600" fontStyle="italic">
                          Composition: {med.chemicalcomposition}
                        </Text>
                      )}
                      {med.medicinetype && (
                        <Text fontSize="12px" color="gray.600">
                          Type: {med.medicinetype}
                        </Text>
                      )}
                    </Td>
                    
                    <Td 
                      fontSize="14px" 
                      borderRight="1px solid" 
                      borderColor="gray.300"
                      textAlign="center"
                      verticalAlign="top"
                      py={3}
                      width="120px"
                    >
                      <Box>
                        <Text fontWeight="bold" fontSize="15px" whiteSpace="nowrap">
                          {med.morning || 0} - {med.afternoon || 0} - {med.night || 0}
                        </Text>
                        <Text fontSize="11px" color="gray.600" mt={0}>
                          (M - A - N)
                        </Text>
                      </Box>
                    </Td>
                    
                    <Td 
                      fontSize="14px" 
                      textAlign="left" 
                      verticalAlign="top"
                      borderRight="1px solid"
                      borderColor="gray.300"
                      py={3}
                    >
                      <Box pl={2}>
                        {med.timing && (
                          <Text fontWeight="semibold" mb={1}>
                            {med.timing}
                          </Text>
                        )}
                        <Text mb={1}>
                          {med.frequency ? `${med.frequency} time(s) daily` : "As directed"}
                        </Text>
                        <Text color="blue.600" fontWeight="semibold" mb={1}>
                          {med.duration !== -1 ? `${med.duration} days` : "Regular"}
                        </Text>
                        {med.customtext && (
                          <Box mt={2} borderRadius="md">
                            <Text fontSize="12px" color="gray.700" fontStyle="italic">
                              <Text as="span" fontWeight="bold">Note:</Text> {med.customtext}
                            </Text>
                          </Box>
                        )}
                      </Box>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
          
          {/* Legend for Dose Column */}
          <Box mt={3} p={2} bg="gray.50" borderRadius="md" width="full">
            <Text fontSize="14px" color="gray.600" textAlign="center">
              <Text as="span" fontWeight="bold">Dose Legend:</Text> Morning - Afternoon - Night
            </Text>
          </Box>
        </Box>
        </VStack>
      )}


        {/* Footer */}
        {/* <Flex justify="space-between" align="center" mt={8} pt={4} borderTop="1px" borderColor="gray.300">
          <Text fontSize="xs">Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
          <Text fontSize="xs">
            Page 2 of 9 <Text as="span" ml={4} fontWeight="bold">Epic</Text>
          </Text>
        </Flex> */}
      </Box>

      {/* PAGE 4: ASSESSMENT AND PLAN (CONTINUED) */}
      <Box p={8} pt={0} bg="blue.50" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break">
        {/* <Heading as="h1" fontSize="xl" fontWeight="bold" mb={6}>Assessment and Plan (continued)</Heading> */}

            <Divider borderColor="gray.300" my="12px" />

<Box mb={8}>
  {/* Medications Prescribed Section */}
{orders.medication && orders.medication.length > 0 && (
  <Box mb={8}>
    {/* Section Header */}
    <Box 
      // bg="linear-gradient(135deg, #4a5568 0%, #2d3748 100%)" 
      // bg="gray.400"
      color="gray.600" 
      w='100%'
      // p={4} 
      borderRadius="xl" 
      mt={6}
      mb={4}
      textAlign="left"
    >
      <Heading as="h1" fontSize="2xl" fontWeight="bold">
        💊 Medications Prescribed
      </Heading>
      {/* <Text fontSize="md" opacity={0.9}>
        Detailed Medical Assessment and Treatment Plan
      </Text> */}
    </Box>

    <VStack spacing={4} align="stretch">
      {orders.medication.map((med, index) => {
        // Calculate duration in days
        const startDate = new Date(med.medicationstartdate);
        const endDate = new Date(med.medicationenddate);
        const durationDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
        
        // Format frequency display
        const frequencyParts = [];
        if (med.morning) frequencyParts.push("morning");
        if (med.afternoon) frequencyParts.push("afternoon");
        if (med.evening) frequencyParts.push("evening");
        if (med.night) frequencyParts.push("night");
        const frequencyDisplay = frequencyParts.join(", ");
        
        // Format timing
        const timing = [];
        if (med.beforefood) timing.push("before food");
        if (med.afterfood) timing.push("after food");
        const timingStr = timing.join(" or ") || "any time";

        // Create the sentence format
        const frequencyText = med.frequency === "1" ? "once" : `${med.frequency} times`;
        const timingText = timingStr !== "any time" ? ` ${timingStr}` : "";
        
        const durationSentence = `Take this medicine ${frequencyText} every ${frequencyDisplay}${timingText} for ${durationDays} days, from ${new Date(med.medicationstartdate).toLocaleDateString()} to ${new Date(med.medicationenddate).toLocaleDateString()}, as prescribed by ${med.prescribedby} at ${med.prescribedhospitalname}.`;

        return (
          <Box 
            key={index}
            bg="white"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.200"
            p={5}
            mt={2}
            boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          >
            {/* Medicine Header */}
            <Flex align="center" mb={3}>
              <Box 
                bg="gray.100" 
                color="gray.600" 
                borderRadius="full" 
                w={8} 
                h={8} 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                fontSize="sm"
                fontWeight="bold"
                mr={3}
              >
                {index + 1}
              </Box>
              <Box>
                <Heading as="h2" fontSize="xl" fontWeight="bold" color="gray.800">
                  {/* {med.medicinetype && `${med.medicinetype}`} */}
                  {med.medicinename}
                  {med.dosage && ` (${med.dosage}${med.dosageunit || ''})`} 
                  {med.chemicalcomposition && <Text as="span" fontWeight="semibold">{` / ${med.chemicalcomposition}`}</Text>}
                </Heading>
                {med.medicinetype && (
                  <Text fontSize="sm" color="gray.600" fontWeight="medium">
                    {med.medicinetype}
                  </Text>
                )}
              </Box>
            </Flex>

            {/* Medicine Details in Sentence Format */}
            <VStack align="start" spacing={2} fontSize="md">
              {(med.drugclass || med.therapeuticcategory) && (
                <Text>
                  <Text as="span" fontWeight="semibold">Drug Class:</Text> {med.drugclass} | <Text as="span" fontWeight="semibold">Therapeutic Category:</Text> {med.therapeuticcategory}
                </Text>
              )}

              {/* Duration and Treatment Details in Sentence Format */}
              <Box width="100%">
                <Text fontWeight="semibold" mb={1}>Duration:</Text>
                <Box 
                  // bg="gray.50" 
                  // p={3} 
                  pl={3}
                  borderRadius="md"
                >
                  <Text fontSize="sm">
                    <Text as="span" fontWeight="semibold">Take this medicine </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{frequencyText}</Text>
                    <Text as="span" fontWeight="semibold"> every </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{frequencyDisplay}</Text>
                    {timingText && (
                      <>
                        <Text as="span" fontWeight="semibold"> </Text>
                        <Text as="span" fontWeight="bold" color="blue.600">{timingText}</Text>
                      </>
                    )}
                    <Text as="span" fontWeight="semibold"> for </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{durationDays} days</Text>
                    <Text as="span" fontWeight="semibold">, from </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{new Date(med.medicationstartdate).toLocaleDateString()}</Text>
                    <Text as="span" fontWeight="semibold"> to </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{new Date(med.medicationenddate).toLocaleDateString()}</Text>
                    <Text as="span" fontWeight="semibold">, as prescribed by </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{med.prescribedby}</Text>
                    <Text as="span" fontWeight="semibold"> at </Text>
                    <Text as="span" fontWeight="bold" color="blue.600">{med.prescribedhospitalname}</Text>
                    <Text as="span" fontWeight="semibold">.</Text>
                  </Text>
                </Box>
              </Box>

              {/* Instructions */}
              {med.custommessage && (
                <Box width="100%">
                  <Text fontWeight="semibold" mb={1}>Instructions:</Text>
                  <Box 
                    bg="gray.50" 
                    p={3} 
                    borderRadius="md"
                    borderLeft="3px solid"
                    borderColor="gray.300"
                  >
                    <Text fontSize="sm" fontStyle="italic">
                      {med.custommessage}
                    </Text>
                  </Box>
                </Box>
              )}
            </VStack>
          </Box>
        );
      })}
    </VStack>
  </Box>
)}
</Box>

{/* <Box display='flex' alignItems='center' justifyContent='center'> */}
<Box align="center" mt="2.5rem" spacing="8px" mx="auto">
          <Text fontSize="12px" textAlign="center">
            Summary generated by
          </Text>
          <Image
            src="assets/svgs/miDocLogo.svg"
            alt="miDoc Logo"
            height="40px"
          />
        </Box>
        {/* <Box mb={4}>
          <Text fontSize="xs" lineHeight="relaxed">
            <Box mb={4}>
              <Text as="strong">ALBUTEROL 90 MCG/</Text>
              <br />
              <Text as="strong">ACTUATION INHL INHALER</Text>
              <Box ml={4} mt={2}>
                Inhale 2 puffs into the lungs every 4 (four) hours as needed for wheezing or shortness of breath
              </Box>
            </Box>

            <Box mb={4}>
              <Text as="strong">AMOXICILLIN-POT CLAVULANATE (AUGMENTIN) 875-125 MG TABLET</Text>
              <Box ml={4} mt={2}>
                Take 1 tablet by mouth in the morning and 1 tablet before bedtime. Do all this for 7 days.
              </Box>
            </Box>

            <Box mb={4}>
              <Text as="strong">PREDNISOLONE (DELTASONE) 20 MG TABLET</Text>
              <Box ml={4} mt={2}>
                Take 1 tablet by mouth in the morning and 1 tablet before bedtime. Do all this for 5 days.
              </Box>
            </Box>
          </Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">Results for orders placed or performed in visit on 08/28/25</Text>
          <br />
          <Text as="strong">X-ray chest PA and lateral</Text>
          <br />
          <Text as="em">Impression</Text>
          <br />
          <Text fontSize="xs" mt={2}>
            Piedmont Urgent Care by Wellstreet
            <br />
            2520 N Decatur Rd Decatur, GA 30033
            <br />
            (678) 685-8100
            <br />
            <br />
            Patient Name:
            <br />
            SHAHBAZ, SYED &nbsp;&nbsp;&nbsp; DOB: &nbsp;&nbsp; 1/17/78
            <br />
            Patient MRN: 914018410 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Gender:
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; M
            <br />
            Study Date: Aug 28, 2025, 10:26:43 AM EDT &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Accession:
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; FWH42291079
            <br />
            Description: &nbsp;&nbsp; XR CHEST PA AND LATERAL
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Ref Phys: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Joseph Temple, NP
            <br />
            Number of Views:
            <br />
            HISTORY / PRELIM DIAGNOSIS: Joseph Temple, NP 678-685-8100 Chest Pain R/O Pneumonia and any abnormalities
            S.H
          </Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">Examination</Text>
          <br />
          <Text fontSize="xs" mt={2}>Description: Chest xray, frontal and lateral views</Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">Comparisons:</Text>
          <br />
          <Text fontSize="xs">
            <Text as="em">None provided.</Text>
          </Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">Findings</Text>
          <br />
          <Text fontSize="xs">The cardiomediastinal silhouette is unremarkable.</Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs">
            Bilateral bronchial wall thickening with posterior medial left lower lobe opacity
          </Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs">No pleural effusion is noted.</Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs">There is no pneumothorax present.</Text>
        </Box> */}

        {/* Footer */}
        {/* <Flex justify="space-between" align="center" mt={8} pt={4} borderTop="1px" borderColor="gray.300">
          <Text fontSize="xs">Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
          <Text fontSize="xs">
            Page 4 of 9 <Text as="span" ml={4} fontWeight="bold">Epic</Text>
          </Text>
        </Flex> */}
      </Box>

      {/* PAGE 3: ASSESSMENT AND PLAN (CONTINUED) */}
      {/* <Box p={8} bg="white" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break">
        <Heading as="h1" fontSize="xl" fontWeight="bold" mb={6}>Assessment and Plan (continued)</Heading>

        <Box mb={6}>
          <Text as="strong">Vitals this encounter:</Text>
          <br />
          <Box ml={4} fontSize="xs" lineHeight="relaxed">
            <Text>Vitals: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 08/28/25 1317</Text>
            <Text>
              BP: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 150/90
            </Text>
            <Text>Pulse: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 95</Text>
            <Text>Resp: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18</Text>
            <Text>
              Temp: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 98.5 °F (36.9 °C)
            </Text>
            <Text>TempSrc: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Oral</Text>
            <Text>SpO2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 98%</Text>
          </Box>
        </Box>

        <Box mb={6}>
          <Text as="strong" textDecoration="underline">Adult Remedies</Text>
          <br />
          <Box ml={4} fontSize="xs" lineHeight="relaxed" mt={2}>
            <Text>-Increasing water intake</Text>
            <Text>-Electrolyte solutions (pedialyte, powerade ZERO gatorade ZERO)</Text>
            <Text>-Hot tea with lemon and honey (local honey helps relieve seasonal allergies)</Text>
            <Text>-Tablespoon of honey - coats throat</Text>
            <Text>-Hot Soups / broth / popsicles</Text>
            <Text>-Saline nasal irrigations (Neti Pot)</Text>
            <Text>-Saline nasal spray (hydration of nasal passageways)</Text>
            <Text>-Warm salt water gargles - helps sore throat</Text>
            <Text>-Hot packs / ice packs / Hot epsom salt baths - body aches / muscle pains</Text>
            <Text>-Cool mist humidifier</Text>
            <Text>-Soft peppermint candy (watch for choking hazard)</Text>
          </Box>
        </Box>

        <Box mb={6}>
          <Text as="strong" textDecoration="underline">OTC medications</Text>
          <br />
          <Box ml={4} fontSize="xs" lineHeight="relaxed" mt={2}>
            <Text>-Ibuprofen / Tylenol - can use up to every 8 hours</Text>
            <Text>-Vitamin C / Zinc</Text>
            <Text>-Delsym - PM cough</Text>
            <Text>-Cepacol - cough drops - have benzocaine to numb throat</Text>
            <Text>-Lidocaine throat spray</Text>
            <Text>-Cetirizine (Zyrtec) / Xyzal - congestion / daily allergy - non drowsy</Text>
            <Text>-Flonase / Nasacort - runny nose / congestion</Text>
            <Text>-Coricidin HBP - decongestant for patients with high blood pressure</Text>
            <Text>-Sudafed (behind the counter, age 18+) - decongestant</Text>
          </Box>
        </Box>

        <Box mb={6}>
          <Text as="strong">Diagnoses this encounter:</Text>
          <Box ml={4} fontSize="xs" mt={2}>
            <Flex justify="space-between">
              <Box>
                <Text>&nbsp;</Text>
                <Text>
                  <Text as="strong">1. &nbsp;&nbsp;&nbsp;&nbsp; Chest pain, unspecified type</Text>
                </Text>
              </Box>
              <Box textAlign="right">
                <Text>ICD-10:</Text>
                <Text>CM</Text>
                <Text>
                  <Text as="strong">R07.9</Text>
                </Text>
              </Box>
              <Box textAlign="right">
                <Text>
                  <Text as="strong">ECG 12 lead</Text>
                </Text>
                <Text>
                  <Text as="strong">X-ray chest PA and lateral</Text>
                </Text>
              </Box>
            </Flex>
          </Box>
        </Box>

        <Box mb={6}>
          <Text as="strong">Orders Placed</Text>
          <br />
          <Box bg="gray.200" h={6} mt={2}>
            <Text as="strong" ml={2}>New Prescriptions</Text>
          </Box>
        </Box>

        <Flex justify="space-between" align="center" mt={8} pt={4} borderTop="1px" borderColor="gray.300">
          <Text fontSize="xs">Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
          <Text fontSize="xs">
            Page 3 of 9 <Text as="span" ml={4} fontWeight="bold">Epic</Text>
          </Text>
        </Flex>
      </Box> */}

      {/* PAGE 5: ASSESSMENT AND PLAN (CONTINUED) */}
      {/* <Box p={8} bg="white" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break">
        <Heading as="h1" fontSize="xl" fontWeight="bold" mb={6}>Assessment and Plan (continued)</Heading>

        <Box mb={4}>
          <Text fontSize="xs">The soft tissues and bones are unremarkable for age.</Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">IMPRESSION:</Text>
          <br />
          <Text fontSize="xs" mt={2}>
            Bronchial wall thickening with posterior medial left lower lobe opacity, possibly pneumonia
          </Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs" lineHeight="relaxed">
            Electronically signed on Aug 28, 2025, 1:44:07 PM EDT (ET) by:
            <br />
            Patricia Burkhart M.D.
            <br />
            Note: This report describes relevant significant findings, based on the clinical setting and information
            provided.
            <br />
            Further details, consultation or follow-up imaging may be obtained as clinically indicated.
          </Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">ECG 12 lead</Text>
          <br />
          <Text as="em">Impression</Text>
          <br />
          <Text fontSize="xs" mt={2}>
            NSR @ rate of 94
            <br />
            No ST elevation
            <br />
            P-wave, T-wave, QRS WNL
          </Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs" lineHeight="relaxed">
            I have gone over the discharge instructions and reviewed the warning signs/symptoms requiring immediate
            return or follow-up in the ED for re-evaluation. I have reviewed and discussed with patient the test(s)
            and/or imaging studies completed in this visit. Educated patient on side effects of prescribed medications
            including those that may interfere with patient's ability to safely operate a motor vehicle. Relevant
            medication side effects have been discussed and reviewed with the patient and/or patient's family member or
            caretaker. The patient has also received instructions, and contact information, for outpatient follow up.
            The patient (or the patient's advocate) in the urgent care has verbalized understanding of everything
            discussed and is ready for discharge.
          </Text>
        </Box>

        <Box mb={6}>
          <Text as="strong">Patient Instruction and Education:</Text>
          <br />
          <Text fontSize="xs" lineHeight="relaxed" mt={2}>
            You were seen in the urgent care today for the above diagnosis. Please be aware that you might have other
            medical problems that were not addressed today. For this you should seek appropriate care with your PCP, a
            specialist, or in the Emergency Department. Please follow all instructions from the medical provider you saw
            today in the urgent care. Please continue taking your other medications from your other medical providers as
            prescribed, unless otherwise directed by the medical provider in the urgent care. Please keep all follow-up
            visits you have with any other provider as scheduled.
          </Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs" lineHeight="relaxed">
            If you notice any adverse effect/reaction to any treatments or medications, seek medical attention
            immediately by contacting or going to your primary care provider, any urgent care, or to the emergency
            department. Delay in evaluation and/or medical treatment/management for any adverse effects or worsening of
            symptoms, illness or injury/ injuries may lead to more serious problems or death.
          </Text>
        </Box>

        <Flex justify="space-between" align="center" mt={8} pt={4} borderTop="1px" borderColor="gray.300">
          <Text fontSize="xs">Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
          <Text fontSize="xs">
            Page 5 of 9 <Text as="span" ml={4} fontWeight="bold">Epic</Text>
          </Text>
        </Flex>
      </Box> */}

      {/* PAGE 6: ASSESSMENT AND PLAN (CONTINUED) */}
      {/* <Box p={8} bg="white" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break">
        <Heading as="h1" fontSize="xl" fontWeight="bold" mb={6}>Assessment and Plan (continued)</Heading>

        <Text fontSize="xs" lineHeight="relaxed" mb={6}>
          If you had an x-ray today, please know that x-rays are not always able to provide all the information. Monitor
          your symptoms and take the recommended medications (medication or over the counter) as instructed.
          <br />
          <br />
          Please always refer to the directions (if available) provided by your discharge packet for more information.
          Monitor your symptoms and take the recommended medications (medication or over the counter) as instructed.
          <br />
          <br />
          Your PCR is listed as: No summary are provided on file.
          <br />
          <br />
          The phone number for everyone who has a Primary Care Provider (PCP) to follow up with and to discuss your test
          results. The phone number for everyone who has a primary care provider (or can call the number mentioned in
          the process of getting one.
          <br />
          <br />
          If you have been prescribed any controlled medication or alprazolam (Benzoyl), please be aware that many of
          these medications may cause a feeling of drowsiness, may cause a danger to yourself or others.
          <br />
          <br />
          If you have been prescribed opioid (pain pills) including but not limited to codeine, oxycodone, hydrocodone,
          morphine, fentanyl, tramadol, and dihydrocodeine, please be aware that these medications have serious risks,
          including addiction and overdose. Do not share these medications with others.
          <br />
          <br />
          Methods of disposal of leftover medication vary by different municipalities and to determine what methods are
          preferred refer to your local health department, local pharmacy, or the DEA's department to determine what
          methods are preferred or available in your community.
          <br />
          <br />
          Abnormal vital signs were discussed and/or addressed.
          <br />
          <br />
          If no BP documented it will flag as critical. This text will autodetele when the note is signed (Optional:
          212659521)
          <br />
          <br />
          This patient has a high risk complaint. Consider additional documentation. This text will not be present in
          the final note (2862-1).
          <br />
          <br />
          <Box textAlign="right" mt={8}>
            NOTE: PIEDMONT URGENT CARE BY WELLSTREET DOES NOT PROVIDE REFILL ON ANY CONTROLLED
            <br />
            PRESCRIPTION MEDICATIONS) AT ANY OF OUR URGENT CARE CENTERS. PLEASE FOLLOW UP WITH YOUR PRIMARY
            <br />
            CARE PHYSICIAN OR SPECIALIST FOR ADDITIONAL MANAGEMENT AND REFILLS ON MEDICATIONS).
            <br />
            <br />
            Joseph L Temple, NP
            <br />
            2:24 PM
            <br />
            <br />
            <Box textAlign="right">Page 6 of 9</Box>
            <br />
            <br />
            Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM
          </Box>
        </Text>

        <Flex justify="space-between" align="center" mt={8} pt={4} borderTop="1px" borderColor="gray.300">
          <Text fontSize="xs">Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
          <Text fontSize="xs">
            Page 6 of 9 <Text as="span" ml={4} fontWeight="bold">Epic</Text>
          </Text>
        </Flex>
      </Box> */}

      {/* PAGE 8: YOUR MEDICATION LIST */}
      {/* <Box p={8} bg="white" minH="11in" fontFamily="sans-serif" fontSize="sm" lineHeight="tight" className="page-break" position="relative">
        <Box transform="rotate(-90)" transformOrigin="left" position="absolute" left={8} top="50%">
          <Heading as="h1" fontSize="xl" fontWeight="bold" whiteSpace="nowrap">Your Medication List</Heading>
          <Text fontSize="xs" mt={2} whiteSpace="nowrap">as of August 28, 2025 2:24 PM</Text>
        </Box>

        <Box ml={16} mt={8}>
          <Box mb={8}>
            <Flex align="center" mb={4}>
              <Box bg="black" color="white" borderRadius="full" w={8} h={8} display="flex" alignItems="center" justifyContent="center" fontSize="sm" fontWeight="bold" mr={4}>
                1
              </Box>
              <Box>
                <Text fontWeight="bold">albuterol 90 mcg/actuation inhaler</Text>
                <Text fontSize="xs">Started by: Joseph Temple</Text>
              </Box>
            </Flex>
            <Text fontSize="xs" ml={12}>
              Inhale 2 puffs into the lungs every 4 (four) hours as needed for wheezing or shortness of breath
            </Text>
          </Box>

          <Box mb={8}>
            <Flex align="center" mb={4}>
              <Box bg="black" color="white" borderRadius="full" w={8} h={8} display="flex" alignItems="center" justifyContent="center" fontSize="sm" fontWeight="bold" mr={4}>
                2
              </Box>
              <Box>
                <Text fontWeight="bold">amoxicillin-pot clavulanate 875-125 mg tablet</Text>
                <Text fontSize="xs">Started by: Joseph Temple</Text>
              </Box>
            </Flex>
            <Text fontSize="xs" ml={12}>
              Take 1 tablet by mouth in the morning and 1 tablet before bedtime. Do all this for 7 days.
            </Text>
          </Box>

          <Box mb={8}>
            <Flex align="center" mb={4}>
              <Box bg="black" color="white" borderRadius="full" w={8} h={8} display="flex" alignItems="center" justifyContent="center" fontSize="sm" fontWeight="bold" mr={4}>
                3
              </Box>
              <Box>
                <Text fontWeight="bold">predniSONE 20 MG tablet</Text>
                <Text fontSize="xs">Started by: Joseph Temple</Text>
              </Box>
            </Flex>
            <Text fontSize="xs" ml={12}>
              Take 1 tablet by mouth in the morning and 1 tablet before bedtime. Do all this for 5 days.
            </Text>
          </Box>
        </Box>

        <Box position="absolute" bottom={8} right={8} transform="rotate(90)" transformOrigin="right">
          <Text fontSize="xs">Page 8 of 9</Text>
          <Text fontSize="xs" mt={2}>Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
        </Box>

        <Flex justify="space-between" align="center" mt={8} pt={4} borderTop="1px" borderColor="gray.300">
          <Text fontSize="xs">Syed Shahbaz (MRN: 914018410) • Printed at 8/28/2025 2:24 PM</Text>
          <Text fontSize="xs">
            Page 8 of 9 <Text as="span" ml={4} fontWeight="bold">Epic</Text>
          </Text>
        </Flex>
      </Box> */}
    </Box>
  
  );
};

export default VisitSummary;
